import { EventEmitter } from '../eventEmitter';

type AuthEvents = {
  notAuthenticated: string;
};

export const authEvents = new EventEmitter<AuthEvents>();
